<template>
  <v-dialog
    v-model="show"
    fullscreen
    transition="dialog-bottom-transition"
    persistent
  >
    <v-card color="grey lighten-3">
      <v-toolbar>
        <v-btn icon @click="closeAttachDocumentsDialog(false)">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <v-toolbar-title>Anexar Documentos</v-toolbar-title>
        <v-spacer/>
        <v-btn @click="save()"
               color="green"
               class="white--text"
               :disabled="!valid"
               :loading="saveLoading">
          <v-icon left>mdi-content-save</v-icon>
          Salvar
        </v-btn>
      </v-toolbar>
      <v-card-text v-if="coords" style="height: calc(100vh - 80px); overflow-y: auto">
        <v-layout column style="height: 100%">
          <v-layout class="mb-3" align-center>
            <span
              v-if="queueFiles.length === 0"
              class="mr-3 subheading font-weight-bold grey--text text--darken-2"
            >
              Nenhum arquivo carregado
            </span>
            <span
              v-else
              class="mr-3 subheading font-weight-bold grey--text text--darken-2"
            >
              {{ queueFiles.length }} arquivo{{ queueFiles.length !== 1 ? 's' : ''}} carregado{{ queueFiles.length !== 1 ? 's' : ''}}
            </span>
            <v-btn color="blue" class="white--text">
              <v-icon left>mdi-cloud-upload</v-icon>
              Enviar Arquivos
              <input
                id="uploader"
                class="white custom-uploader"
                type="file"
                multiple
                @change="mountQueue"
                accept=".pdf, .mp3, .kml"
              />
            </v-btn>
          </v-layout>

          <v-layout class="full" wrap>

            <!-- Upload Container -->
            <div
              :class="{
                'pa-3 upload-container': true,
                'full': queueFiles.length === 0,
                'xs4 file-card mr-3 mb-3': queueFiles.length > 0
              }"
              style="position: relative"
            >
              <input
                id="uploader1"
                class="custom-uploader"
                type="file"
                multiple
                @change="mountQueue"
                accept=".pdf, .mp3, .kml"
              />
              <img
                src="/static/images/document/upload.svg"
                :class="{'mb-3': true, 'upload-card-icon' : this.queueFiles.length > 0}"
              />
              <span class="mb-3 title font-weight-bold blue--text">Enviar Arquivos</span>
              <span
                :class="{
                  'subheading': this.queueFiles.length === 0,
                  'grey--text': true,
                  'text-xs-center': true,
                }"
              >
                Selecione um ou múltiplos arquivos para adicionar ao processo. <br/>
                Formatos de arquivos aceitos: <strong>PDF, KML</strong> ou <strong>MP3</strong>.
              </span>
            </div>

            <!-- Documents Attached -->
            <v-flex
              class="mb-3 mr-3"
              xs4
              v-for="(item, index) in queueFiles"
              :key="item.file.name"
              style="max-height: 200px; max-width: 440px"
            >

              <document-attached
                :index="index"
                :item="item"
                @removeFile="removeFile(index)"
                @setDocumentType="setDocumentType"
              />

            </v-flex>
          </v-layout>
        </v-layout>
      </v-card-text>
      <v-card-text v-else>
        <v-alert
          color="#fb8c00"
          :value="true"
          type="warning"
          style="text-align: center"
        >
          Para enviar arquivos, você deve permitir o acesso a sua localização.
        </v-alert>
      </v-card-text>
    </v-card>
    <alert-dialog :showLoader="showAlertDialog" :message="errorMessage" @close="showAlertDialog = false"/>
  </v-dialog>
</template>

<script>
  import { forEach, filter, isEmpty, find } from 'lodash';
  import documentsService from '@/services/DocumentsService';
  import LoaderDialog from '@/components/LoaderDialog';
  import AlertDialog from '@/components/AlertDialog';
  import DocumentAttached from './DocumentAttached';

  export default {
    name: 'AttachDocumentsDialog',
    components: {
      AlertDialog,
      DocumentAttached,
      LoaderDialog,
    },
    async mounted() {
      this.coords = await (this.getLocation());
    },
    props: {
      id: {
        type: String,
        default: '',
      },
      show: {
        typ: Boolean,
        default: false,
      },
    },
    data() {
      return {
        coords: null,
        queueFiles: [],
        processingQueue: false,
        reprocessQueue: false,

        saveLoading: false,
        showAlertDialog: false,

        isEmpty,

        errorMessage: '',
      };
    },
    methods: {
      mountQueue(event) {
        const vm = this;

        let filesRepeted = [];

        forEach(event.target.files, (file) => {
          let result = find(vm.queueFiles, (item) => {
            return item.file.name === file.name && item.file.size === file.size
          });
          if (result === undefined) {
            vm.queueFiles.push({ file, progress: 0, payload: null, show: true, sended: false });
          } else {
            filesRepeted.push(file.name)
          }
        });

        if (!isEmpty(filesRepeted)) {
          this.$store.dispatch('toggleSnackbar', {
            show: true,
            color: 'red',
            message: `O(s) arquivo(s) '${ filesRepeted.join(', ') }' já se encontra(m) na lista.`,
            button: { show: true, text: 'Fechar', message: '' },
            timeout: 6000,
            messageIcon: 'mdi-file-document-box-remove-outline',
          });
        }


        document.getElementById('uploader').value = '';
        document.getElementById('uploader1').value = '';
      },
      async uploadFilesInQueue() {
        this.reprocessQueue = false;
        this.processingQueue = true;

        for (const [index, item] of this.queueFiles.entries()) {
          if (item.progress === 0) {
            try {
              let response = await this.uploadFile(item);
              item['payload'] = response.data;
            } catch (error) {
              let errors = '';
              if (error.response.status == 422) {
                errors = 'Verifique os seguintes erros: </br>' +
                  error.response.data.join(', ');
              } else {
                errors = 'Erro interno no Servidor!'
              }
              this.errorMessage = errors;
              this.showAlertDialog = true;
              this.queueFiles.splice(index, this.queueFiles.length)
              break;
            }
          }
        }

        this.processingQueue = false;
        if (this.reprocessQueue) {
          this.uploadFilesInQueue()
        }
      },
      async uploadFile(item) {
        const formData = new FormData();
        formData.append('document[file]', item.file)
        return await (documentsService
          .createNewPDFDocument(this.folder.id,
            formData,
            (progress) => {
              item.progress = Math.round((progress.loaded * 100) / progress.total)
            }));
      },
      removeFile(index) {
        this.queueFiles[index].show = false;
        setTimeout(() => {
          this.queueFiles.splice(index, 1);
        }, 500)

      },
      closeAttachDocumentsDialog(updateFolder) {
        this.queueFiles = [];
        this.saveLoading = false;
        this.processingQueue = false;
        this.reprocessQueue = false;
        this.$emit('closeAttachDocumentsDialog');

        if (updateFolder) {
          this.$store.dispatch('toggleLoader', { show: true });
          this.$store.dispatch('getActiveFolder', { id: this.folder.id })
            .finally(() => {
              this.$store.dispatch('toggleLoader', { show: false });
            });
        }

      },
      setDocumentType(payload) {
        this.queueFiles[payload.index].payload.documentTypeId = payload.documentTypeId
        this.queueFiles = [...this.queueFiles];
      },
      async save() {
        this.saveLoading = true;
        try {
          for (const item of this.queueFiles) {
            const document = {
              document_id: item.payload.id,
              document_type_id: item.payload.documentTypeId,
            };

            let response = await (documentsService
              .updatePDFDocument(item.payload.id, document, `${ this.coords.lat }, ${ this.coords.lng }`));
            item.sended = true;
          }

          this.$store.dispatch('toggleSnackbar', {
            show: true,
            color: 'success',
            message: 'Documentos enviados com sucesso',
            button: { show: true, text: 'Fechar', message: '' },
            timeout: 6000,
          });

          this.closeAttachDocumentsDialog(true);
        } catch (e) {
          console.log(e);
          console.log(e.response.data);
          this.$store.dispatch('toggleSnackbar', {
            show: true,
            color: 'red',
            message: 'Erro ao atualizar o(s) arquivo(s) com seus respectivos tipos.',
            button: { show: true, text: 'Fechar', message: '' },
            timeout: 6000,
            messageIcon: 'mdi-check-outline',
          });
        }

        this.saveLoading = false;

      },
      async getLocation() {
        try {
          const response = await (this.$getLocation())
          return response;
        } catch (e) {
          this.$store.dispatch('toggleSnackbar', {
            show: true,
            color: 'red',
            message: 'Não foi possível obter sua localização. Autorize o seu navegador a obter a localização para continuar',
            button: { show: true, text: 'Fechar', message: '' },
            timeout: 6000,
            messageIcon: 'mdi-check-outline',
          });
        }
      },
    },
    computed: {
      folder() {
        return this.$store.getters.activeFolder;
      },
      valid() {
        return filter(this.queueFiles, 'payload.documentTypeId').length === this.queueFiles.length &&
          !isEmpty(this.queueFiles);
      },
    },
    watch: {
      queueFiles(newValue) {
        if (this.processingQueue) {
          this.reprocessQueue = true;
        } else {
          this.uploadFilesInQueue();
        }
      },
    }
  };
</script>

<style>
  .custom-card-text {
    display: flex;
    height: calc(100vh - 48px);
    overflow: hidden;
  }

  .upload-container {
    cursor: pointer;
    border: 2px dashed #4185f4;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .full {
    height: 100%;
    width: 100%;
    transition: all .5s;
  }

  .custom-uploader {
    cursor: pointer;
    height: 100%;
    width: 100%;
    position: absolute;
    z-index: 99;
    opacity: 0;
    border: 18px solid black;
  }

  .file-card {
    transition: all .5s;
    width: 440px;
    height: 200px;
  }

  .upload-card-icon {
    width: 64px;
    height: 62px;
  }
</style>



// WEBPACK FOOTER //
// src/components/document/new/AttachDocumentsDialog.vue